/* global BigInt */
/* eslint-disable no-unused-expressions */

var sat = () => {
  var t = {
      821: (t, e) => {
        Object.defineProperty(e, "__esModule", { value: !0 }),
          (e.EPOCH_SATS =
            e.HALVING_INTERVAL =
            e.COIN_VALUE =
            e.SUBSIDY_HALVING_INTERVAL =
            e.DIFFCHANGE_INTERVAL =
            e.SAT_LAST =
            e.SAT_SUPPLY =
            e.CYCLE_EPOCHS =
              void 0),
          (e.CYCLE_EPOCHS = 6),
          (e.SAT_SUPPLY = 2099999997690000n),
          (e.SAT_LAST = 2099999997689999n),
          (e.DIFFCHANGE_INTERVAL = 2016),
          (e.SUBSIDY_HALVING_INTERVAL = 21e4),
          (e.COIN_VALUE = 100000000n),
          (e.HALVING_INTERVAL = 210000n),
          (e.EPOCH_SATS = [
            0n,
            1050000000000000n,
            1575000000000000n,
            1837500000000000n,
            1968750000000000n,
            2034375000000000n,
            2067187500000000n,
            2083593750000000n,
            2091796875000000n,
            2095898437500000n,
            2097949218750000n,
            2098974609270000n,
            2099487304530000n,
            2099743652160000n,
            2099871825870000n,
            2099935912620000n,
            2099967955890000n,
            2099983977420000n,
            2099991988080000n,
            2099995993410000n,
            2099997995970000n,
            2099998997250000n,
            2099999497890000n,
            2099999748210000n,
            2099999873370000n,
            2099999935950000n,
            2099999967240000n,
            2099999982780000n,
            2099999990550000n,
            2099999994330000n,
            2099999996220000n,
            2099999997060000n,
            2099999997480000n,
            2099999997690000n,
          ]);
      },
      888: (t, e) => {
        Object.defineProperty(e, "__esModule", { value: !0 }),
          (e.DecimalSat = void 0);
        class r {
          height;
          offset;
          constructor(t, e) {
            (this.height = t), (this.offset = e);
          }
          static fromSat(t) {
            return new r(t.height(), t.third());
          }
          toString() {
            return `${this.height.toString()}.${this.offset.toString()}`;
          }
        }
        e.DecimalSat = r;
      },
      454: (t, e, r) => {
        Object.defineProperty(e, "__esModule", { value: !0 });
        const n = r(821);
        class i {
          hour;
          minute;
          second;
          third;
          constructor(t, e, r, n) {
            (this.hour = t),
              (this.minute = e),
              (this.second = r),
              (this.third = n);
          }
          toString() {
            return `${this.hour}°${this.minute}′${this.second}″${this.third}‴`;
          }
          static fromSat(t) {
            const e = t.height().n(),
              r = Math.floor(
                Number(e / (n.CYCLE_EPOCHS * n.SUBSIDY_HALVING_INTERVAL))
              ),
              o = Number(e % n.SUBSIDY_HALVING_INTERVAL),
              a = Number(e % n.DIFFCHANGE_INTERVAL),
              s = t.third();
            return new i(r, o, a, s);
          }
        }
        e.default = i;
      },
      417: function (t, e, r) {
        var n =
          (this && this.__importDefault) ||
          function (t) {
            return t && t.__esModule ? t : { default: t };
          };
        Object.defineProperty(e, "__esModule", { value: !0 }),
          (e.fromHeightToEpoch = e.fromSatToEpoch = void 0);
        const i = r(821),
          o = n(r(557)),
          a = n(r(752));
        class s {
          static FIRST_POST_SUBSIDY = new s(33);
          epoch;
          constructor(t) {
            this.epoch = t;
          }
          n() {
            return this.epoch;
          }
          static STARTING_SATS() {
            return i.EPOCH_SATS.map((t) => new a.default(t));
          }
          subsidy() {
            return this.lt(s.FIRST_POST_SUBSIDY)
              ? BigInt(50n * i.COIN_VALUE) >> BigInt(this.epoch)
              : 0n;
          }
          startingSat() {
            const t = Math.min(this.epoch, s.STARTING_SATS().length - 1);
            return s.STARTING_SATS()[t];
          }
          startingHeight() {
            return new o.default(this.epoch * i.SUBSIDY_HALVING_INTERVAL);
          }
          equals(t) {
            return this.epoch === t;
          }
          lt(t) {
            return this.epoch < t.epoch;
          }
        }
        (e.default = s),
          (e.fromSatToEpoch = function (t) {
            const e = s.STARTING_SATS().findIndex((e) => t.lt(e));
            return new s(-1 === e ? 33 : e - 1);
          }),
          (e.fromHeightToEpoch = function (t) {
            return new s(Math.floor(t.n() / i.SUBSIDY_HALVING_INTERVAL));
          });
      },
      557: (t, e, r) => {
        Object.defineProperty(e, "__esModule", { value: !0 });
        const n = r(821),
          i = r(417);
        class o {
          height;
          constructor(t) {
            this.height = t;
          }
          n() {
            return this.height;
          }
          toString() {
            return this.height.toString();
          }
          subsidy() {
            return (0, i.fromHeightToEpoch)(this).subsidy();
          }
          startingSat() {
            const t = (0, i.fromHeightToEpoch)(this),
              e = t.startingSat(),
              r = t.startingHeight();
            return e.add(BigInt(this.n() - r.n()) * t.subsidy());
          }
          periodOffset() {
            return this.height % n.DIFFCHANGE_INTERVAL;
          }
          add(t) {
            return new o(this.height + t);
          }
          sub(t) {
            return new o(this.height - t);
          }
          equals(t) {
            return this.height === t;
          }
        }
        e.default = o;
      },
      752: function (t, e, r) {
        var n =
          (this && this.__importDefault) ||
          function (t) {
            return t && t.__esModule ? t : { default: t };
          };
        Object.defineProperty(e, "__esModule", { value: !0 });
        const i = r(821),
          o = r(888),
          a = n(r(454)),
          s = r(417),
          h = r(873);
        class u {
          static LAST = new u(i.SAT_SUPPLY - 1n);
          value;
          constructor(t) {
            this.value = t;
          }
          add(t) {
            return new u(this.value + t);
          }
          addAssign(t) {
            this.value += t;
          }
          lt(t) {
            return this.value < t.value;
          }
          n() {
            return this.value;
          }
          decimal() {
            return new o.DecimalSat(this.height(), this.third());
          }
          rarity() {
            const t = (0, h.rarityFromSat)(this);
            return h.Rarity[t];
          }
          rarityEmoji() {
            const t = this.rarity();
            let e = h.RarityEmojiType.Common;
            return (
              t === h.Rarity.Mythic
                ? (e = h.RarityEmojiType.Mythic)
                : t === h.Rarity.Legendary
                ? (e = h.RarityEmojiType.Legendary)
                : t === h.Rarity.Epic
                ? (e = h.RarityEmojiType.Epic)
                : t === h.Rarity.Rare
                ? (e = h.RarityEmojiType.Rare)
                : t === h.Rarity.Uncommon && (e = h.RarityEmojiType.Uncommon),
              e
            );
          }
          rarityColor() {
            const t = this.rarity();
            let e = h.RarityColorType.Common;
            return (
              t === h.Rarity.Mythic
                ? (e = h.RarityColorType.Mythic)
                : t === h.Rarity.Legendary
                ? (e = h.RarityColorType.Legendary)
                : t === h.Rarity.Epic
                ? (e = h.RarityColorType.Epic)
                : t === h.Rarity.Rare
                ? (e = h.RarityColorType.Rare)
                : t === h.Rarity.Uncommon && (e = h.RarityColorType.Uncommon),
              e
            );
          }
          degree() {
            return a.default.fromSat(this);
          }
          height() {
            let t = this.epoch(),
              e = Number(this.epochPosition() / t.subsidy());
            return t.startingHeight().add(e);
          }
          cycle() {
            const t = this.epoch().epoch;
            return Math.floor(t / i.CYCLE_EPOCHS);
          }
          nineball() {
            let t = this.n();
            return t >= 50n * i.COIN_VALUE * 9n && t < 50n * i.COIN_VALUE * 10n;
          }
          percentile() {
            const t = (this.value * BigInt(1e32)) / u.LAST.value;
            if (0n === t) return "0%";
            if (t / BigInt(1e30)) {
              const e = (Number(t) / 1e30).toFixed(12);
              return `${e.substring(0, e.length - 2)}%`;
            }
            {
              const e = (Number(t) / 1e30).toFixed(22);
              return `${e.substring(0, e.length - 2)}%`;
            }
          }
          epoch() {
            return (0, s.fromSatToEpoch)(this);
          }
          period() {
            return Math.floor(this.height().n() / i.DIFFCHANGE_INTERVAL);
          }
          third() {
            return this.epochPosition() % this.epoch().subsidy();
          }
          epochPosition() {
            return this.value - this.epoch().startingSat().n();
          }
          timestamp(t) {
            const e = this.height().n();
            if (t > e) return "";
            const r = 600 * (e - t),
              n = Date.now() + 1e3 * r;
            return new Date(n).toISOString() + "(expected)";
          }
          name() {
            let t = i.SAT_SUPPLY - this.value,
              e = "";
            for (; t > 0n; ) {
              (e += "abcdefghijklmnopqrstuvwxyz"[Number((t - 1n) % 26n)]),
                (t = (t - 1n) / 26n);
            }
            return e.split("").reverse().join("");
          }
          static fromName(t) {
            let e = 0n;
            for (const r of t) {
              if (!(r >= "a" && r <= "z"))
                throw new Error(`invalid character in sat name: ${r}`);
              if (
                ((e =
                  26n * e + BigInt(r.charCodeAt(0) - "a".charCodeAt(0)) + 1n),
                e > i.SAT_SUPPLY)
              )
                throw new Error("sat name out of range");
            }
            return new u(i.SAT_SUPPLY - e);
          }
          static fromSat(t) {
            if (!t.match(/^[0-9]+$/)) throw new Error("Invalid sat format");
            const e = BigInt(t);
            if (e > i.SAT_SUPPLY) throw new Error("Invalid sat");
            return new u(e);
          }
        }
        e.default = u;
      },
      873: (t, e) => {
        var r, n, i;
        Object.defineProperty(e, "__esModule", { value: !0 }),
          (e.rarityFromSat =
            e.RarityEmojiType =
            e.RarityColorType =
            e.Rarity =
              void 0),
          (function (t) {
            (t.Mythic = "Mythic"),
              (t.Legendary = "Legendary"),
              (t.Epic = "Epic"),
              (t.Rare = "Rare"),
              (t.Uncommon = "Uncommon"),
              (t.Common = "Common");
          })(r || (e.Rarity = r = {})),
          (function (t) {
            (t.Mythic = "#f2a900"),
              (t.Legendary = "#ffd700"),
              (t.Epic = "#9932cc"),
              (t.Rare = "#6495ed"),
              (t.Uncommon = "#228b22"),
              (t.Common = "#808080");
          })(n || (e.RarityColorType = n = {})),
          (function (t) {
            (t.Mythic = "👑"),
              (t.Legendary = "🌝"),
              (t.Epic = "🪻"),
              (t.Rare = "🧿"),
              (t.Uncommon = "🌱"),
              (t.Common = "🪙");
          })(i || (e.RarityEmojiType = i = {})),
          (e.rarityFromSat = function (t) {
            const { hour: e, minute: n, second: i, third: o } = t.degree();
            return 0 === e && 0 === n && 0 === i && 0n === o
              ? r.Mythic
              : 0 === n && 0 === i && 0n === o
              ? r.Legendary
              : 0 === n && 0n === o
              ? r.Epic
              : 0 === i && 0n === o
              ? r.Rare
              : 0n === o
              ? r.Uncommon
              : r.Common;
          });
      },
      507: function (t, e, r) {
        var n =
          (this && this.__importDefault) ||
          function (t) {
            return t && t.__esModule ? t : { default: t };
          };
        Object.defineProperty(e, "__esModule", { value: !0 });
        const i = n(r(454)),
          o = n(r(417)),
          a = n(r(557)),
          s = 2099999997689999n,
          h = 693e4;
        e.default = class {
          value;
          constructor(t = 6929999) {
            const e = -1 < t && t < h ? t : 6929999,
              r = new a.default(e);
            this.value = r.startingSat().value;
          }
          setSat(t) {
            return (this.value = t > s ? s : t), this;
          }
          rarity() {
            const { hour: t, minute: e, second: r, third: n } = this.degree();
            return 0 === t && 0 === e && 0 === r && 0n === n
              ? "Mythic"
              : 0 === e && 0 === r && 0n === n
              ? "Legendary"
              : 0 === e && 0n === n
              ? "Epic"
              : 0 === r && 0n === n
              ? "Rare"
              : 0n === n
              ? "Uncommon"
              : "Common";
          }
          box() {
            const t = this.rarity();
            let e = "🪙",
              r = "#808080";
            return (
              "Mythic" === t
                ? ((e = "👑"), (r = "#f2a900"))
                : "Legendary" === t
                ? ((e = "🌝"), (r = "#ffd700"))
                : "Epic" === t
                ? ((e = "🪻"), (r = "#9932cc"))
                : "Rare" === t
                ? ((e = "🧿"), (r = "#6495ed"))
                : "Uncommon" === t && ((e = "🌱"), (r = "#228b22")),
              { sat: this.value.toString(), rarity: t, emoji: e, color: r }
            );
          }
          degree() {
            return i.default.fromSat(this);
          }
          height() {
            let t = this.epoch(),
              e = t.subsidy(),
              r = Number(this.epochPosition() / e);
            return t.startingHeight().add(r);
          }
          cycle() {
            const t = this.epoch().epoch;
            return Math.floor(t / 6);
          }
          epoch() {
            const t = o.default
              .STARTING_SATS()
              .findIndex((t) => this.value < t.value);
            return new o.default(-1 === t ? 33 : t - 1);
          }
          period() {
            return Math.floor(this.height().n() / 2016);
          }
          third() {
            return this.epochPosition() % this.epoch().subsidy();
          }
          epochPosition() {
            return this.value - this.epoch().startingSat().n();
          }
        };
      },
    },
    e = {};
  var r = (function r(n) {
    var i = e[n];
    if (void 0 !== i) return i.exports;
    var o = (e[n] = { exports: {} });
    return t[n].call(o.exports, o, o.exports, r), o.exports;
  })(507);
  return r;
};
var box = (h) => {
  let satbox = sat().default;
  return new satbox(h);
};
exports.satbox = box;
